module.exports = __webpack_public_path__ + "img/failed-icon.8668ecfc.svg";